import { useState } from "react";
import { BrowserView, isMobile } from "react-device-detect";
import { useTranslation } from "react-i18next";

export default function AboutUs(props){
    const { t } = useTranslation();
    const links = ["Residential","Commercial","Yatching","Cource"];

    const [selectedTabIndex,setSelectedTabIndex] = useState(0);

    return(
        <>
            <div className="content-and-image">
                    <div id="content">
                        <div id="text-left">
                            <div>
                                <div id='title'>{t('À propos de nous')}</div>
                                <br/>
                                <br/>
                                <div id = 'text'>{t('L’agence immobilière LM Platinum Estates est une entreprise camerounaise immobilière qui a un engagement sérieux avec la satisfaction du client au premier plan. À travers une équipe d’agents expérimentés et un travail acharné, nous proposons de nombreux services à l’intention des vendeurs, des investisseurs et des locataires. Active sur le marché de l’immobilier au Cameroun, nous préconisons fortement l’innovation, l’honnêteté et la transparence. En effet, compte tenu des challenges et des défis sur le marché de l’immobilier de nos jours et surtout au Cameroun, nous visons l’excellence.')}</div>
                                <br/>
                                <br/>
                                <br/>
                            </div>
                        </div>
                        
                        <div id="image">
                            <img src="5379637510122105177.jpg"/>
                        </div>
                    </div>
            </div>
        </>
    )
}
